// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"wW-z","inlineTitle":"xW-z","sponsoredAdsWrapper":"yW-z","marketplaceRecosWrapper":"zW-z"};